import { registerConfigurationAction } from '../config/registerClientConfig';
import { HpAction, HpDispatchFunction } from '../types';
import { fetchResolver } from './fetchResolver';

export type HpGetAuthenticatedUserPayload = Record<string, never>;

export type HpGetAuthenticatedUserAction = HpAction<HpGetAuthenticatedUserPayload>;

let websiteEndpoint: string;
registerConfigurationAction((config) => {
  ({ websiteEndpoint } = config);
});

export function getAuthenticatedUserAction(): HpActionReturnType {
  return (dispatch: HpDispatchFunction<HpGetAuthenticatedUserPayload>) => {
    const url = `${websiteEndpoint}/api/authenticated-user`;
    return fetchResolver({
      options: { url, method: 'GET', description: `Get authenticated user` },
      dispatch,
      successAction: (payload) => {
        dispatch({ type: 'RECEIVE_AUTHENTICATED_USER', payload });
      }
    });
  };
}

type HpActionReturnType = (dispatch: HpDispatchFunction<HpGetAuthenticatedUserPayload>) => Promise<void>;
